import { initializeApp } from 'firebase/app';
import { initializeAuth, getAuth, GoogleAuthProvider, EmailAuthProvider, OAuthProvider, indexedDBLocalPersistence } from 'firebase/auth';
import { getMessaging, onMessage as firebaseOnMessage, getToken as firebaseGetToken } from 'firebase/messaging';

// Try iOS-specific config for better compatibility
const firebaseConfig = {
  apiKey: "AIzaSyAJCKQLg7HSsNQwIHMTMimJ18qnGNBfQgI",
  authDomain: "tulidu-prod.firebaseapp.com",
  projectId: "tulidu-prod",
  storageBucket: "tulidu-prod.firebasestorage.app",
  messagingSenderId: "36562032704",
  appId: "1:36562032704:ios:6eaf9c1e39cb40da6a67a5"
};

const app = initializeApp(firebaseConfig);

// Initialize auth based on platform
let auth;
const isIOS = typeof window !== 'undefined' && window.Capacitor && window.Capacitor.getPlatform() === 'ios';

if (isIOS) {
  // For iOS, use indexedDB persistence to fix WebView authentication issues
  try {
    auth = initializeAuth(app, {
      persistence: indexedDBLocalPersistence
    });
    console.log('🔐 Firebase Auth: Initialized with indexedDB persistence for iOS');
  } catch (error) {
    // Fallback to default auth if indexedDB fails
    console.warn('🔐 Firebase Auth: indexedDB initialization failed on iOS, using default auth:', error);
    auth = getAuth(app);
  }
} else {
  // For web and other platforms, use default auth (required for signInWithPopup)
  auth = getAuth(app);
  console.log('🔐 Firebase Auth: Using default auth for web/other platforms');
}

export { auth };
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Apple Sign-In provider
export const appleProvider = new OAuthProvider('apple.com');
appleProvider.addScope('email');
appleProvider.addScope('name');

// Email/Password authentication is enabled by default in Firebase
// No additional provider setup needed for email/password auth

// FCM Messaging - only for web platform
let messaging = null;
let onMessage = null;
let getToken = null;

// Only initialize messaging on web platform (not in Capacitor)
if (!window.Capacitor || !window.Capacitor.isNativePlatform()) {
  try {
    messaging = getMessaging(app);
    onMessage = firebaseOnMessage;
    getToken = firebaseGetToken;
  } catch (error) {
    console.warn('Firebase messaging not available:', error);
  }
}

export { messaging, onMessage, getToken }; 